module.exports = __webpack_public_path__ + "static/media/icomoon.d2add55c.svg";